<p-dialog
  header="Envoyer un mail"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '1100px' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onHide()"
>
  <div class="send-mail-modal-content">
    <!-- Sélection de la réponse standardisée -->
    <div class="field mb-4">
      <label for="standardResponse" class="block font-medium mb-2">
        Réponse standardisée
      </label>

      <div
        *ngIf="loadingStandardResponses"
        class="flex align-items-center gap-2"
      >
        <p-progressSpinner
          [style]="{ width: '20px', height: '20px' }"
          styleClass="spinner-small"
        ></p-progressSpinner>
        <span class="text-sm text-color-secondary">Chargement...</span>
      </div>

      <p-select
        *ngIf="!loadingStandardResponses"
        id="standardResponse"
        [(ngModel)]="selectedStandardResponse"
        [options]="standardResponses"
        optionLabel="label"
        placeholder="Sélectionner une réponse standardisée"
        [style]="{ width: '100%' }"
        [filter]="true"
        filterPlaceholder="Rechercher..."
        appendTo="body"
        (onChange)="onStandardResponseChange()"
      ></p-select>
    </div>

    <!-- Aperçu du contenu du mail -->
    <div
      *ngIf="loadingMailContent"
      class="flex align-items-center justify-content-center py-4"
    >
      <p-progressSpinner
        [style]="{ width: '40px', height: '40px' }"
      ></p-progressSpinner>
      <span class="ml-2">Chargement du contenu...</span>
    </div>

    <div *ngIf="mailContent && !loadingMailContent" class="mail-preview">
      <div class="mail-columns">
        <!-- Colonne gauche : sujet, destinataires, contenu -->
        <div class="mail-column-left">
          <div class="field mb-3">
            <label class="block font-medium mb-1 text-sm">Sujet</label>
            <div class="p-3 surface-100 border-round">
              {{ mailContent.content.subject }}
            </div>
          </div>

          <!-- Destinataires -->
          <div class="field mb-3">
            <label class="block font-medium mb-1 text-sm"
              >Destinataires (À)</label
            >
            <div
              class="flex flex-wrap gap-2 mb-2"
              *ngIf="editableRecipientsTo.length > 0"
            >
              <p-chip
                *ngFor="let recipient of editableRecipientsTo; let i = index"
                [label]="recipient"
                [removable]="true"
                (onRemove)="removeRecipientTo(i)"
              ></p-chip>
            </div>
            <input
              type="email"
              pInputText
              placeholder="Ajouter un email et appuyer sur Entrée..."
              class="w-full"
              (keydown.enter)="addRecipientTo($event)"
            />
          </div>

          <div class="field mb-3">
            <label class="block font-medium mb-1 text-sm"
              >Destinataires (Cc)</label
            >
            <div
              class="flex flex-wrap gap-2 mb-2"
              *ngIf="editableRecipientsCopy.length > 0"
            >
              <p-chip
                *ngFor="let recipient of editableRecipientsCopy; let i = index"
                [label]="recipient"
                [removable]="true"
                (onRemove)="removeRecipientCopy(i)"
              ></p-chip>
            </div>
            <input
              type="email"
              pInputText
              placeholder="Ajouter un email en copie..."
              class="w-full"
              (keydown.enter)="addRecipientCopy($event)"
            />
          </div>

          <!-- Alerte documents manquants -->
          <div
            *ngIf="mailContent.files.missingRequiredDocuments?.hasAnyMissing"
            class="p-3 bg-yellow-100 border-round mb-3 flex align-items-start gap-2"
          >
            <i class="pi pi-exclamation-triangle text-yellow-700"></i>
            <span class="text-yellow-700 text-sm">
              {{ mailContent.files.missingRequiredDocuments.message }}
            </span>
          </div>

          <!-- Éditeur du contenu -->
          <div class="field mb-3">
            <label class="block font-medium mb-1 text-sm"
              >Contenu du mail</label
            >
            <p-editor
              [(ngModel)]="editableContent"
              [style]="{ height: '250px' }"
            ></p-editor>
          </div>
        </div>

        <!-- Colonne droite : pièces jointes -->
        <div class="mail-column-right">
          <!-- Pièces jointes par catégorie -->
          <div class="field">
            <label class="block font-medium mb-2 text-sm">Pièces jointes</label>

            <!-- Documents clients -->
            <ng-container
              *ngIf="mailContent.files.documentsCustomers.length > 0"
            >
              <div class="file-category mb-3">
                <div
                  class="file-category-header flex align-items-center gap-2 mb-2"
                >
                  <p-checkbox
                    [binary]="true"
                    [ngModel]="
                      allSelected(mailContent.files.documentsCustomers)
                    "
                    (onChange)="
                      toggleAllFiles(
                        mailContent.files.documentsCustomers,
                        $event.checked
                      )
                    "
                  ></p-checkbox>
                  <span class="font-medium text-sm">Documents clients</span>
                  <span class="text-xs text-color-secondary">
                    ({{ mailContent.files.documentsCustomers.length }})
                  </span>
                </div>
                <div class="file-category-items pl-4">
                  <div
                    *ngFor="let file of mailContent.files.documentsCustomers"
                    class="flex align-items-center gap-2 mb-1"
                  >
                    <p-checkbox
                      [binary]="true"
                      [(ngModel)]="file.isSelected"
                    ></p-checkbox>
                    <i class="pi pi-file text-color-secondary text-sm"></i>
                    <span
                      class="text-sm text-overflow-ellipsis overflow-hidden white-space-nowrap"
                      [title]="file.basename"
                    >
                      {{
                        file.additionalInformations?.documentName ||
                          file.basename
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Documents livrés -->
            <ng-container
              *ngIf="mailContent.files.documentsDelivered.length > 0"
            >
              <div class="file-category mb-3">
                <div
                  class="file-category-header flex align-items-center gap-2 mb-2"
                >
                  <p-checkbox
                    [binary]="true"
                    [ngModel]="
                      allSelected(mailContent.files.documentsDelivered)
                    "
                    (onChange)="
                      toggleAllFiles(
                        mailContent.files.documentsDelivered,
                        $event.checked
                      )
                    "
                  ></p-checkbox>
                  <span class="font-medium text-sm">Documents livrés</span>
                  <span class="text-xs text-color-secondary">
                    ({{ mailContent.files.documentsDelivered.length }})
                  </span>
                </div>
                <div class="file-category-items pl-4">
                  <div
                    *ngFor="let file of mailContent.files.documentsDelivered"
                    class="flex align-items-center gap-2 mb-1"
                  >
                    <p-checkbox
                      [binary]="true"
                      [(ngModel)]="file.isSelected"
                    ></p-checkbox>
                    <i class="pi pi-file text-color-secondary text-sm"></i>
                    <span
                      class="text-sm text-overflow-ellipsis overflow-hidden white-space-nowrap"
                      [title]="file.basename"
                    >
                      {{
                        file.additionalInformations?.documentName ||
                          file.basename
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Factures -->
            <ng-container *ngIf="mailContent.files.invoices.length > 0">
              <div class="file-category mb-3">
                <div
                  class="file-category-header flex align-items-center gap-2 mb-2"
                >
                  <p-checkbox
                    [binary]="true"
                    [ngModel]="allSelected(mailContent.files.invoices)"
                    (onChange)="
                      toggleAllFiles(mailContent.files.invoices, $event.checked)
                    "
                  ></p-checkbox>
                  <span class="font-medium text-sm">Factures</span>
                  <span class="text-xs text-color-secondary">
                    ({{ mailContent.files.invoices.length }})
                  </span>
                </div>
                <div class="file-category-items pl-4">
                  <div
                    *ngFor="let file of mailContent.files.invoices"
                    class="flex align-items-center gap-2 mb-1"
                  >
                    <p-checkbox
                      [binary]="true"
                      [(ngModel)]="file.isSelected"
                    ></p-checkbox>
                    <i class="pi pi-file text-color-secondary text-sm"></i>
                    <span
                      class="text-sm text-overflow-ellipsis overflow-hidden white-space-nowrap"
                      [title]="file.basename"
                    >
                      {{
                        file.additionalInformations?.documentName ||
                          file.basename
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Devis -->
            <ng-container *ngIf="mailContent.files.quotations.length > 0">
              <div class="file-category mb-3">
                <div
                  class="file-category-header flex align-items-center gap-2 mb-2"
                >
                  <p-checkbox
                    [binary]="true"
                    [ngModel]="allSelected(mailContent.files.quotations)"
                    (onChange)="
                      toggleAllFiles(
                        mailContent.files.quotations,
                        $event.checked
                      )
                    "
                  ></p-checkbox>
                  <span class="font-medium text-sm">Devis</span>
                  <span class="text-xs text-color-secondary">
                    ({{ mailContent.files.quotations.length }})
                  </span>
                </div>
                <div class="file-category-items pl-4">
                  <div
                    *ngFor="let file of mailContent.files.quotations"
                    class="flex align-items-center gap-2 mb-1"
                  >
                    <p-checkbox
                      [binary]="true"
                      [(ngModel)]="file.isSelected"
                    ></p-checkbox>
                    <i class="pi pi-file text-color-secondary text-sm"></i>
                    <span
                      class="text-sm text-overflow-ellipsis overflow-hidden white-space-nowrap"
                      [title]="file.basename"
                    >
                      {{
                        file.additionalInformations?.documentName ||
                          file.basename
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Pièces jointes -->
            <ng-container *ngIf="mailContent.files.attachments.length > 0">
              <div class="file-category mb-3">
                <div
                  class="file-category-header flex align-items-center gap-2 mb-2"
                >
                  <p-checkbox
                    [binary]="true"
                    [ngModel]="allSelected(mailContent.files.attachments)"
                    (onChange)="
                      toggleAllFiles(
                        mailContent.files.attachments,
                        $event.checked
                      )
                    "
                  ></p-checkbox>
                  <span class="font-medium text-sm">Pièces jointes</span>
                  <span class="text-xs text-color-secondary">
                    ({{ mailContent.files.attachments.length }})
                  </span>
                </div>
                <div class="file-category-items pl-4">
                  <div
                    *ngFor="let file of mailContent.files.attachments"
                    class="flex align-items-center gap-2 mb-1"
                  >
                    <p-checkbox
                      [binary]="true"
                      [(ngModel)]="file.isSelected"
                    ></p-checkbox>
                    <i class="pi pi-file text-color-secondary text-sm"></i>
                    <span
                      class="text-sm text-overflow-ellipsis overflow-hidden white-space-nowrap"
                      [title]="file.name || file.basename"
                    >
                      {{
                        file.name ||
                          file.additionalInformations?.documentName ||
                          file.basename
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </ng-container>

            <div
              *ngIf="
                mailContent.files.documentsCustomers.length === 0 &&
                mailContent.files.documentsDelivered.length === 0 &&
                mailContent.files.invoices.length === 0 &&
                mailContent.files.quotations.length === 0 &&
                mailContent.files.attachments.length === 0
              "
              class="text-sm text-color-secondary"
            >
              Aucun fichier disponible
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button
        label="Annuler"
        icon="pi pi-times"
        (onClick)="closeModal()"
        styleClass="p-button-text"
        [disabled]="sending"
      ></p-button>
      <p-button
        label="Envoyer"
        icon="pi pi-send"
        (onClick)="sendMail()"
        [disabled]="!mailContent || sending || loadingMailContent"
        [loading]="sending"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
